import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import { BaseTableAssetTitle } from "./BaseTableAssetTitle";
export const PublicTableAssetTitle = /*#__PURE__*/ memo((props)=>/*#__PURE__*/ _jsx(BaseTableAssetTitle, {
        ...props
    }));
PublicTableAssetTitle.displayName = "PublicTableAssetTitle";
